import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { LinkFont, InlineLink } from 'modules/styled';
import { s3, alert } from 'app/utils';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from 'modules/auth/auth.actions';
import { Form, Field } from 'react-final-form';
import { Form as StyledForm, View, Button } from 'modules/styled/web';
import {
  image,
  email,
  username,
  password,
  confirmPassword,
} from 'modules/auth/form.fields';
import { passwordsShouldMatch } from 'modules/form/validators';

const Alert = alert.Alert();

ProfileForm.propTypes = {
  initialValues: PropTypes.object,
  additionalFields: PropTypes.object,
  close: PropTypes.func,
};

export default function ProfileForm({
  initialValues = {},
  additionalFields = {},
  close,
}) {
  const { ethLogin, signupCallback } = additionalFields;
  const signup = useSignUp(additionalFields, close, signupCallback);
  const onSubmit = useOnSubmit(signup);

  const showEmailField = initialValues.email ? null : email;
  const showPass = ethLogin ? null : password;
  const showConfirmPass = showPass ? confirmPassword : null;

  const FORM_FIELDS = [image, username, showEmailField, showPass, showConfirmPass].filter(
    (f) => f
  );

  return (
    <Form
      // validateOnBlur={true}
      // validateOnChange={true}
      onSubmit={onSubmit}
      validate={passwordsShouldMatch}
      initialValues={initialValues}
      mutators={{
        triggerValidation(fieldsToValidate, state, { changeValue }) {
          fieldsToValidate.forEach((fieldName) => {
            changeValue(state, fieldName, (n) => n);
          });
        },
      }}
      render={({ handleSubmit, form }) => (
        <StyledForm onSubmit={handleSubmit}>
          {FORM_FIELDS.map((field) => (
            <Field {...field} key={field.name} form={form} />
          ))}
          <View sx={{ justifyContent: 'flex-end', mt: 6, alignItems: 'center' }}>
            <LinkFont>
              By signing up, you agree to our{' '}
              <InlineLink
                to="//relevant.community/eula.html"
                external
                target="_blank"
                inline={1}
              >
                <LinkFont sx={{ color: 'blue' }}>Terms of Use</LinkFont>
              </InlineLink>
            </LinkFont>
            <Button type="submit" sx={{ ml: 3 }}>
              Sign Up
            </Button>
          </View>
        </StyledForm>
      )}
    />
  );
}

function useOnSubmit(signup) {
  return useCallback(
    async (vals) => {
      try {
        const allVals = { ...vals };
        if (allVals.image && allVals.image.preview && allVals.image.fileName) {
          const img = await s3.uploadFile(allVals.image.preview, allVals.image.fileType);
          allVals.image = img;
        }
        signup(allVals);
      } catch (err) {
        Alert.alert(err.message, 'error');
      }
    },
    [signup]
  );
}

function useSignUp(additionalFields, close, signupCallback) {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { invitecode } = auth;

  return useCallback(
    async (data) => {
      try {
        const user = {
          name: data.username,
          email: data.email,
          password: data.password,
          image: data.image,
          ...additionalFields,
        };
        await dispatch(createUser(user, invitecode));
        signupCallback && signupCallback(user);
        close();
      } catch (err) {
        Alert.alert(err.message, 'error');
      }
    },
    [additionalFields, dispatch, invitecode, close, signupCallback]
  );
}
